
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            getterTranslates: 'getterTranslates',
            getterStoreLang	: 'getterStoreLang'
        }),
	},
}
